<template>
  <v-dialog
    v-model="dialogModel"
    :max-width="$vuetify.breakpoint.smAndDown ? 400 : 800"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <div
        :class="{
          'pa-4': !isMobile,
          'pa-2': isMobile
        }"
      >
        <popup-header
          :title="$t('msg.addingDateAndTime')"
          class="mb-4"
          @click-close="close()"
        ></popup-header>
        <v-form
          class="task-time__form"
          :class="{
            'task-time__form_table': $vuetify.breakpoint.smAndDown,
            'task-time__form_mobile': isMobile,
          }"
        >
          <v-select
            v-model="model.type"
            :label="$t('msg.type')"
            :items="types"
            :loading="typesLoading"
            class="task-time__input"
            outlined
            :dense="!isMobile"
            hide-details="auto"
          >
            <template v-slot:selection="{item}">
              {{ $t('timeType.' + item) }}
            </template>
            <template v-slot:item="{item}">
              {{ $t('timeType.' + item) }}
            </template>
          </v-select>
          <v-dialog
            v-if="model.type === 'one'"
            v-model="dateDialog"
            width="290"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="getDateString"
                :error-messages="errors.collect('_date')"
                data-vv-name="_date"
                :label="$t('msg.date')"
                readonly
                class="task-time__input"
                clearable
                v-on="on"
                v-validate="'required'"
                outlined
                :dense="!isMobile"
                hide-details="auto"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="model._date"
              scrollable
              :locale="$store.getters.lang"
              @change="changeDate()"
              :first-day-of-week="1"
              title="sdf"
            ></v-date-picker>
          </v-dialog>
          <v-select
            v-if="model.type === 'every_year'"
            v-model="model.month_of_year"
            :error-messages="errors.collect('month_of_year')"
            data-vv-name="month_of_year"
            :label="$t('msg.month')"
            :items="months"
            class="task-time__input"
            item-value="id"
            clearable
            v-validate="'required'"
            outlined
            :dense="!isMobile"
            hide-details="auto"
          >
            <template v-slot:selection="{item}">
              {{ $t('month.' + item) }}
            </template>
            <template v-slot:item="{item}">
              {{ $t('month.' + item) }}
            </template>
          </v-select>
          <v-select
            v-if="model.type === 'every_week'"
            v-model="model.day_of_week"
            :error-messages="errors.collect('day_of_week')"
            data-vv-name="day_of_week"
            :label="$t('msg.dayWeek')"
            :items="daysOfWeek"
            class="task-time__input"
            item-value="id"
            clearable
            v-validate="'required'"
            outlined
            :dense="!isMobile"
            hide-details="auto"
          >
            <template v-slot:selection="{item}">
              {{ $t('dayOfWeek.' + item) }}
            </template>
            <template v-slot:item="{item}">
              {{ $t('dayOfWeek.' + item) }}
            </template>
          </v-select>
          <v-select
            v-if="model.type === 'every_month' || model.type === 'every_year'"
            v-model="model.day_of_month"
            :error-messages="errors.collect('day_of_month')"
            data-vv-name="day_of_month"
            :items="daysOfMonth"
            class="task-time__input"
            :label="$t('msg.dayOfMonth')"
            v-validate="'required'"
            clearable
            :disabled="model.type === 'every_year' && model.month_of_year === undefined"
            outlined
            :dense="!isMobile"
            hide-details="auto"
          ></v-select>
          <v-dialog
            v-model="timeDialog"
            width="290"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="model._time"
                :error-messages="errors.collect('_time')"
                data-vv-name="_time"
                :label="$t('msg.time')"
                readonly
                class="task-time__input"
                clearable
                v-on="on"
                :disabled="(model.type === 'one' && model._date === null) ||
                            (model.type === 'every_week' && (model.day_of_week === null || model.day_of_week === undefined)) ||
                            (model.type === 'every_month' && (model.day_of_month === null || model.day_of_month === undefined))"
                v-validate="'required'"
                outlined
                :dense="!isMobile"
                hide-details="auto"
              ></v-text-field>
            </template>
            <v-time-picker
              ref="timePicker"
              v-model="model._time"
              scrollable
              format="24hr"
              :allowed-minutes="v => v%5 === 0"
              @click:minute="timeDialog = false"
            ></v-time-picker>
          </v-dialog>
          <v-btn
            color="primary"
            @click="submit()"
            :small="!isMobile"
            :loading="loading"
            elevation="0"
          >{{ model.id === null ? $t('msg.add') : $t('msg.save') }}
          </v-btn>
        </v-form>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {parse} from "date-fns";
import PopupHeader from "@/components/ui/PopupHeader";

export default {
  components: {PopupHeader},
  props: {
    projectId: null,
    taskId: null,
    index: Number,
    types: Array,
    typesLoading: Boolean,
    modelDialog: Boolean
  },
  data() {
    return {
      dialogModel: false,
      dateDialog: false,
      timeDialog: false,
      loading: false,
      model: {
        id: null,
        time: null,
        day_of_month: null,
        day_of_week: null,
        month_of_year: null,
        type: null,

        _date: null,
        _time: null,
      },
    };
  },
  computed: {
    getDateString() {
      return this.dateString(this.model._date);
    },
    daysOfWeek() {
      let days = [];
      for (let i = 1; i <= 7; i++) {
        days.push(i);
      }
      return days;
    },
    daysOfMonth() {
      let days = [];
      for (let i = 1; i <= 31; i++) {
        days.push(i);
      }
      return days;
    },
    months() {
      let months = [];
      for (let i = 1; i <= 12; i++) {
        months.push(i);
      }
      return months;
    }
  },
  watch: {
    timeDialog(v) {
      if (v) {
        if (this.$refs.timePicker !== undefined) {
          this.$refs.timePicker.selectingMinute = false;
          this.$refs.timePicker.selectingSecond = false;
          this.$refs.timePicker.selectingHour = true;
        }
      }
    },
    dialogModel(v) {
      if (!v) {
        this.close();
      }
    }
  },
  methods: {
    close() {
      this.model.id = null;
      this.model.time = null;
      this.model.day_of_month = null;
      this.model.day_of_week = null;
      this.model.month_of_year = null;
      this.model.type = null;
      this.model._date = null;
      this.model._time = null;

      this.dialogModel = false;
    },
    create() {
      this.model.id = null;
      this.model.time = null;
      this.model.day_of_month = null;
      this.model.day_of_week = null;
      this.model.month_of_year = null;
      this.model.type = null;
      this.model._date = null;
      this.model._time = null;

      this.dialogModel = true;
    },
    open(model) {
      this.model.id = model.id;
      this.model.time = model.time;
      this.model.day_of_month = model.day_of_month;
      this.model.day_of_week = model.day_of_week;
      this.model.month_of_year = model.month_of_year;
      this.model.type = model.type;
      this.model._date = model._date;
      this.model._time = model._time;

      this.dialogModel = true;
    },
    changeDate() {
      this.dateDialog = false;
      this.timeDialog = true;
    },
    submit() {
      if (this.model._date !== null && this.model._time !== null) {

        let day = parse(this.model._date, 'yyyy-MM-dd', new Date());
        this.model.time = parse(this.model._time, 'HH:mm', day);

      } else if (this.model._date !== null && this.model._time === null) {

        this.model.time = parse(this.model._date, 'yyyy-MM-dd', new Date());

      } else if (this.model._date === null && this.model._time !== null) {

        this.model.time = parse(this.model._time, 'HH:mm', new Date());

      } else {

        this.model.time = new Date();
      }

      this.model.time = this.timeLocalToServer(this.model.time);

      this.$validator.validateAll()
        .then(res => {
          if (res) {

            this.loading = true;

            const action = this.model.id === null ? 'createTime' : 'editTime';

            this.$store.dispatch(action, {
              data: this.model,
              id: this.projectId,
              subId: this.taskId,
              subSubId: this.model.id,
              formErrors: this.errors
            })
              .then(res => {
                if (this.model.id === null) {
                  this.model.id = res.id;
                  this.$emit('created', Object.assign({}, this.model));
                } else {
                  this.$emit('updated', Object.assign({}, this.model));
                }

                this.close();
              })
              .finally(() => this.loading = false);
          }
        });
    }
  }
}
</script>

<style lang="scss" scoped>
.task-time__form {
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 5px;
  margin-bottom: 5px;

  &.task-time__form_mobile {
    .task-time__input {
      margin-right: 0;
    }
  }

  &.task-time__form_table {
    flex-direction: column;

    & > div {
      width: 100%;
      min-width: inherit;
      max-width: inherit;
      margin-bottom: 10px;
    }
  }
}

.task-time__input {
  max-width: 165px;
  min-width: 130px;
  margin-right: 15px;
}
</style>